import request from '@/utils/request'

export function addCompany(query) {
  return request({
    url: '/Company/company',
    method: 'post',
    data: query 
  })
}

export function editCompany(query) {
  return request({
    url: '/Company/company',
    method: 'put',
    params: query 
  })
}

export function getCompany(query) {
  return request({
    url: '/Company/company',
    method: 'get',
    params: query 
  })
}

export function departmentList(query) {
  return request({
    url: '/Company/departmentList',
    method: 'get',
    params: query 
  })
}

export function customAddressList(query) {
    return request({
        url: '/Company/customAddressList',
        method: 'get',
        params: query
    })
}
export function getServiceHomePage(query) {
  return request({
      url: '/Company/serviceHomePage',
      method: 'get',
      params: query
  })
}




// WEBPACK FOOTER //
// ./src/api/company.js